import { useEffect, useState } from 'react';
import { useHomeImages } from '@/hooks/useProjects';
import { homeGallery } from '@/data/galleryData';
import { useIsMobile } from '@/hooks/use-mobile';
import { useLang } from '@/i18n/LanguageContext';

const NotFound = () => {
  const { pairs: dbPairs } = useHomeImages();
  const isMobile = useIsMobile();
  const [randomImage, setRandomImage] = useState<string | null>(null);
  const { t, lp } = useLang();

  useEffect(() => {
    const allPairs = dbPairs.length > 0 ? dbPairs : homeGallery;
    if (allPairs.length === 0) return;
    const pair = allPairs[Math.floor(Math.random() * allPairs.length)];
    const img = Math.random() > 0.5 ? pair.left : pair.right;
    setRandomImage(img);
  }, [dbPairs]);

  const monoFont = "'IBM Plex Mono', monospace";

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background overflow-auto" style={{ padding: 32 }}>
      {randomImage && (
        <img src={randomImage} alt="" className="object-cover mb-8" style={{ width: isMobile ? '80vw' : '30vw' }} />
      )}
      <h1 className="uppercase tracking-wider mb-4" style={{ fontFamily: monoFont, fontSize: 24, fontWeight: 300 }}>
        {t('notFound.title')}
      </h1>
      <p className="uppercase mb-8 opacity-60" style={{ fontFamily: monoFont, fontSize: 14, fontWeight: 300 }}>
        {t('notFound.subtitle')}
      </p>
      <a href={lp('/')} className="uppercase nav-link-hover" style={{ fontFamily: monoFont, fontSize: 14, fontWeight: 300, color: '#000', textDecoration: 'underline', textUnderlineOffset: 4 }}>
        {t('notFound.cta')}
      </a>
    </div>
  );
};

export default NotFound;
